import { resolveFeatures } from '../tools/resolve-features';
import { viewZoomTo } from '../tools/view-zoom-to';
import type { Tool } from '../tools/types';

type Input = {
  layer_id: string;
  where: string;
  order_by: string;
  order_dir?: 'ASC' | 'DESC';
};

export const frameTop: Tool<Input> = {
  name: 'frame_top',
  description:
    'Convenience: resolve_features(limit=1, order_by) → view.zoom_to. Frames the single top feature (e.g. "tallest building", "largest mosque") without two round-trips.',
  input_schema: {
    type: 'object',
    properties: {
      layer_id: { type: 'string' },
      where: { type: 'string' },
      order_by: { type: 'string' },
      order_dir: { enum: ['ASC', 'DESC'] },
    },
    required: ['layer_id', 'where', 'order_by'],
    additionalProperties: false,
  },
  execute: async (input) => {
    const resolved = (await resolveFeatures.execute({
      layer_id: input.layer_id,
      where: input.where,
      order_by: input.order_by,
      order_dir: input.order_dir ?? 'DESC',
      limit: 1,
    })) as { handle: string };
    await viewZoomTo.execute({
      source: { kind: 'handle', id: resolved.handle },
      padding: 1.4,
    });
    return { handle: resolved.handle };
  },
};
